export default "__VITE_ASSET__CcP8c0r4__"